import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'

import styles from './LayoutGrid.module.css'

const LayoutRow = ({ children }) => {
  return <div className={styles.row}>{children}</div>
}

const LayoutColumn = ({ children, size }) => {
  return <div className={`${styles.col} ${styles[`col-${size}`]}`}>{children}</div>
}

LayoutRow.propTypes = {
  children: PropTypes.node.isRequired,
}

LayoutColumn.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.number.isRequired,
}

LayoutColumn.defautProps = {
  size: 3,
}

const fragments = {
  paragraph: gql`
    fragment LayoutColumnFragment on ParagraphLayoutColumn {
      id
      size: fieldLayoutColumnSize
      affect: fieldLayoutColumnAffect
    }
  `,
}

export { LayoutRow, LayoutColumn, fragments }
